import cx from "classnames";
import GptAd, { GptAdProps } from "./GptAd";
import styles from "./ArticleRail.module.scss";

const ArticleRailAd = (
  props: GptAdProps & { label?: boolean; boxAdOnly: boolean }
) => {
  const sizes = [
    props.boxAdOnly ? "box" : "rail",
    // Only include native sizes when native targeting is set
    props.targetingNative && "native",
  ]
    .filter((size) => size)
    .join(",");

  return (
    <GptAd
      format="rrail"
      className={cx(
        styles.root,
        props.label && styles.label,
        "s-native s-native--standard s-native--small s-native--short-title"
      )}
      sizesAt0=""
      sizesAt976={sizes}
      {...props}
    />
  );
};

export default ArticleRailAd;
